module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5c540cafeb35fab1d8381f5f3f029536.png";